// https://vuex.vuejs.org/en/mutations.html

import { set } from '@/utils/vuex'

export default {
  setTab: set('activeTab'),
  setRanking: set('ranking')
}
